import React from 'react'
import LeaveCategory from '../Components/LeaveManagement/CreateLeaveCat/LeaveCategory'

const LeaveCatPage = () => {
  return (
    // <div style={{padding:"8px 0px"}} className='NewFormBackColor'>
    <div style={{padding:"8px 0px"}}>
      <LeaveCategory/>
    </div>
  )
}

export default LeaveCatPage
